import { HttpClient } from '../../httpClient'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type CreateContentV2 = OpalApi<'CreateContentV2', 201>
type CreateContentV2ResponseData = OpalApiResponseDocument<
  'CreateContentV2',
  201
>

export const createContent: CreateContentV2 = async ({
  requestBody,
}: Parameters<CreateContentV2>[0] = {}) => {
  const url = new URL('/content/v2', window.location.origin)

  return HttpClient()
    .post<CreateContentV2ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
